import { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useAuth0 } from '../../../../../contexts/auth0-context'
import callAPI from '../../../../../API/callSecureAPI'
import endpoints from '../../../../../API/endpoints'
//import { TPP_CELL_QUERY_KEYS } from '../../TPPCell/queries/useTPPCellQuery'

type UpdateColumnContentsPayload = {
    columnId: string
    tppId: string
    operations: any[]
}

type UseUpdateColumnContentsMutationProps = {
    onSuccess?: () => void
}

export const useUpdateColumnContentsMutation = ({ onSuccess }: UseUpdateColumnContentsMutationProps = {}) => {
    const [controller, setController] = useState<AbortController | null>(null)
    const { getTokenSilently } = useAuth0()

    const updateColumnContents = async ({ columnId, tppId, operations }: UpdateColumnContentsPayload) => {
        console.log('Updating TPP column contents for columnId:', columnId)
        try {
            if (controller) {
                controller.abort()
                setController(null)
            }

            const abortController = new AbortController()
            setController(abortController)

            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            const { url, method } = endpoints.updateTPPColumn

            const finalUrl = url.replace(':columnId', columnId)

            const response = await callAPI(
                finalUrl,
                method,
                token,
                { operations: { operations } },
                { signal: abortController.signal }
            )

            return response.data
        } catch (e) {
            console.error('Error updating TPP column contents', e)
            throw e
        }
    }

    return useMutation(updateColumnContents, {
        onSuccess: async (_data, variables) => {
            // Invalidate any queries that depend on this column/its cells.
            // Adjust keys as needed to match your existing query key helpers.
            //queryClient.invalidateQueries(TPP_CELL_QUERY_KEYS.listByTppId(variables.tppId))
            onSuccess?.()
        },
    })
}
